export default {
  body: {
    margin: 0
  }
};
